module.exports = __webpack_public_path__ + "static/media/viceLogo.445eaf22.svg";